/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PostRefundDto = {
    refundOptionType: PostRefundDto.refundOptionType | null;
};
export namespace PostRefundDto {
    export enum refundOptionType {
        NONE = 'NONE',
        REPAYMENT = 'REPAYMENT',
        CREDITS = 'CREDITS',
        MULTIPASS = 'MULTIPASS',
    }
}

